import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import UserSearchContainer from '../containers/user-search.container';
import {
  DEFAULT_PAGINATION_LIMIT,
  DEFAULT_PAGINATION_PAGE,
} from '../../../../../const/default-paginated-table-data.const';
import TenantGuard from '@components/common/TenantGuard';

// Helper function to add default query parameters to the user search page
const UserSearchWithParams = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  // Set default params if they don't exist
  if (!params.has('page')) {
    params.set('page', DEFAULT_PAGINATION_PAGE.toString());
  }
  if (!params.has('limit')) {
    params.set('limit', DEFAULT_PAGINATION_LIMIT.toString());
  }

  // If query params need to be added
  if (location.search !== `?${params.toString()}`) {
    return <Navigate to={`?${params.toString()}`} replace />;
  }

  return <UserSearchContainer />;
};

export const userSearchRoutes = [
  {
    path: 'search/user-search',
    element: (
      <TenantGuard showHeader={true} headerTitle="User Search" showBreadcrumbs={true}>
        <UserSearchWithParams />
      </TenantGuard>
    ),
  },
];

export default userSearchRoutes;
